export const CompanyInPortsType = {
  Courier: 0,
  GarbageDisposal: 1,
};
